<div class="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
  <h1 class="text-6xl font-bold text-gray-800 mb-4">404</h1>
  <h2 class="text-2xl font-semibold text-gray-600 mb-6">Pagina non trovata</h2>
  <p class="text-gray-500 mb-8 max-w-md">
    Ci dispiace, la pagina che stai cercando non esiste o è stata spostata.
  </p>
  <a routerLink="/" class="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 font-medium">
    Torna alla Home
  </a>
</div>
